
import React , {useRef, useState} from "react"
import Navbar from "./Navbar"
import Sidebar from "./Sidebar"
import Banner from "./parts/banner"
import { useSelector } from "react-redux"
import {FiEyeOff} from "react-icons/fi"
const OnlyOwner = () => {
    const divRef = useRef(null);
    const [height, setHeight] = useState(0)

    const user = useSelector(state => state.getUserInfo.user)
    const impersonateReducer = useSelector(state => state.impersonateReducer.impersonate)
    const demoReducer = useSelector(state => state.demoReducer.demo)
    const cancelReducer = useSelector(state => state.cancelReducer.cancel)
    const sidebarCollapsed = useSelector(state => state.sidebarCollapseReducer.collapsed)

    return(
        <>
            {(JSON.parse(impersonateReducer) || JSON.parse(demoReducer) || JSON.parse(cancelReducer)) && user && <div ref={divRef} id="banner"><Banner setHeight={setHeight} /></div>}
            <Navbar height={height} title="" all={false} groups={true}/>
            <div className={`main-container ${sidebarCollapsed ? 'collapsed' : ''}`} style={{ minHeight: `calc(100vh - ${height + 100}px)` }} >
                <div className='locked-page'>
                    <div className='locked-page'>
                        <div>
                            <div className="slash-eye-wrapper"><FiEyeOff/></div>
                            <h1>Access Denied</h1>
                            <p>Access Restricted to Owner Only.</p>
                        </div>
                    </div>
                </div>
            </div>
            <Sidebar height={height} />
        </>
    )
}
export default OnlyOwner